import React, { useState } from 'react';
import styled from 'styled-components';
import { ActionIconTrash, ButtonRoundTertiary, ParagraphTertiary, SpacerVertical, } from '@klarna/bubble-ui';
import { generateCyElemId } from 'moet-test-utils/cypress/utils';
import { CY_DOCUMENTS_CONTAINER_IDS } from '@/containers/Documents/constants';
const Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-4yn2v4" }) `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  width: 100%;
  height: 50px;

  border-bottom: 1px solid #f0f1f1;
  padding: 10px 15px 10px 15px;
`;
const Title = styled.div.withConfig({ displayName: "Title", componentId: "sc-1rp9nuv" }) `
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  width: calc(100% - 40px);
`;
const Viewer = ({ documents = [], onDeleteDocument }) => {
    const [loading, setLoading] = useState(false);
    const [deleting, setDeleting] = useState([]);
    const deleteDocument = (doc) => () => {
        setDeleting(deleting => [...deleting, doc.attachmentId]);
        setLoading(true);
        onDeleteDocument(doc, () => {
            setDeleting(deleting => deleting.filter(element => element !== doc.attachmentId));
            setLoading(false);
        });
    };
    return (React.createElement(React.Fragment, null, documents.map(doc => (React.createElement(Container, { key: doc.attachmentId },
        React.createElement(Title, null,
            React.createElement(ParagraphTertiary, Object.assign({ correctFootprint: true, 
                // @ts-expect-error: FIXME
                overflowEllipsisWidth: "100%" }, generateCyElemId(CY_DOCUMENTS_CONTAINER_IDS.ELEMENT_DOCUMENT_VIEWER, window)), doc.filename),
            React.createElement(SpacerVertical, { extraSmall: true }),
            doc.size && (
            // @ts-expect-error: FIXME
            React.createElement(ParagraphTertiary, { light: true, correctFootprint: true, overflowEllipsisWidth: "100%" }, doc.size))),
        React.createElement(ButtonRoundTertiary, { size: "small", loading: !!(loading && deleting.find(element => element === doc.attachmentId)), onClick: deleteDocument(doc), "aria-label": "delete" },
            React.createElement(ActionIconTrash, null)))))));
};
export default Viewer;
